import { Component, inject, Signal } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ILoggedInUser } from '../../interfaces/common/loggedInUser';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { SearchParameters } from '../../shared/models/searchParameters.model';
import { PagedResult } from '../../shared/models/pagedResult.model';
import { SearchLineTypesChangesModel } from '../models/search-line-type-changes.model';
import { SearchRequestService } from '../../manage-request/services/search-request.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { LoggedInUserService } from '../../services/common/logged-in-user.service';
import { RequestAndLineTypeService } from '../services/request-and-line-types.service';
import { LineTypeChange } from '../models/line-type-changes.model';
import { ILineType } from '../models/line-type.model';

@Component({
  selector: 'app-line-type-changes',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatProgressSpinnerModule, MatPaginatorModule, MatTableModule],
  templateUrl: './line-type-changes.component.html',
  styleUrl: './line-type-changes.component.scss'
})
export class LineTypeChangesComponent {
  searchForm: FormGroup;
  user: ILoggedInUser;
  isAdmin: boolean = false;
  isLoading: boolean = false;
  totalCount: number;
  pageSize: number = 10;
  pageIndex: number;
  searchDone: boolean = false;
  displayedColumns: string[] = ['number', 'time', 'action', 'requestType','lineType','description','employeeType', 'emplyeeCategory','mode', 'go165', 'isConfidencial', 'recurringBenefit', 'cycle', 'promptType', 'promptText1', 'promptText2', 'promptText3', 'rate', 'rateBenefitBased', 'limit', 'actionBy'];
  currencyModes = [];
  searchRequestParams: SearchParameters<SearchLineTypesChangesModel>;
  pagedData: PagedResult<LineTypeChange[]>;
  dataSource: MatTableDataSource<LineTypeChange>;
  searchRequestService: SearchRequestService = inject(SearchRequestService);
  requestTypesList = toSignal(this.searchRequestService.getAllRequestTypes(), { rejectErrors: true });  
  lineTypesList = toSignal(this.requestAndLineTypeService.getLineTypes(), { rejectErrors: true });
    
  constructor(
    private userService: LoggedInUserService,
    private fb: FormBuilder,
    private requestAndLineTypeService: RequestAndLineTypeService ) 
    {}

  ngOnInit(): void {
    

    this.searchForm = this.fb.group({
      requestType: new FormControl(''),          
      lineTypeName: new FormControl(''),
      lineType: new FormControl(''),
      fromDate: new FormControl(''),
      toDate: new FormControl('')
    });

    this.userService.currentUser$.subscribe(data => {
      this.user = data;
      if(this.user != null && this.user.adminRight){
        this.isAdmin = this.user.adminRight;        
      }      
    });
  }

  submitForm(): void {
    this.searchRequestParams = {
      query: {
        requestType: this.searchForm.get('requestType').value || null,
        lineTypeName: this.searchForm.get('lineTypeName').value || null,
        lineType: this.searchForm.get('lineType').value || null,
        fromDate: this.searchForm.get('fromDate').value || null,
        toDate: this.searchForm.get('toDate').value || null
      },
      pageIndex: 0,
      pageSize: 10,
      userEmail: this.user.userEmail      
    };
    this.search();
  }
    
  search() {
    if(this.isAdmin){
      this.isLoading = true;
      this.requestAndLineTypeService.searchLineTypesChanges(this.searchRequestParams)
        .subscribe(data => {
          this.pagedData = data;
          this.pageSize = this.pagedData.pageSize;
          this.totalCount = this.pagedData.totalCount;      
          this.dataSource = new MatTableDataSource<LineTypeChange>(this.pagedData.items);
          this.isLoading = false;
          this.searchDone = true;
      });
    }
    else{
      this.dataSource = new MatTableDataSource<LineTypeChange>([]);
    }
  }
      
  public pageChangeEvent(event?: PageEvent){
    this.searchRequestParams.pageIndex = event.pageIndex;
    this.searchRequestParams.pageSize = event.pageSize;
    this.search();
  }
}
